import * as React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { usuarioSelector } from '../../selectors/sessionSelector'
import {ofertaSelector} from '../../selectors/ofertaSelector'
import * as ofertaActions from '../../reducers/OfertaReducer/actions'
import OfertaNuevo from '../../components/Oferta/ofertaNuevo'
import * as Notification from '../../components/Common/notification'
import { compress, calculateNewSize } from '../../components/Common/imageCompressor'
import moment from 'moment'

class OfertaNuevoContainer extends React.Component {

    constructor(props) {
        super(props)
        this.state= {
            idOfertaSelected: this.props.dataContenido.ofertas && this.props.dataContenido.ofertaSelected ? this.props.dataContenido.ofertaSelected : undefined,
            usuarioCargado: false,
            ofertasCargadas: this.props.dataContenido.ofertas ? true : false,
            nombre: undefined,
            ofertaSelected: this.props.dataContenido.ofertas ? this.props.dataContenido.ofertas.find(x => x.idOferta === this.props.dataContenido.ofertaSelected) : undefined,
            error: {},
            tag: undefined,

            pathImg: undefined,
            currentFile: undefined,
            fechaDesde: undefined,
            fechaHasta: undefined,
        }

        if(this.props.dataContenido.ofertas === undefined){
            this.props.sagaGetOfertas()
        }
        localStorage.setItem('idOfertaSelected', JSON.stringify({idOfertaSelected:this.props.dataContenido.ofertaSelected}));
    }

    componentDidUpdate = () => {
        if(this.state.usuarioCargado === false && this.props.usuario !== undefined){
            this.setState({usuarioCargado: true}, () => {
                if(this.props.usuario.idRol === 4){                    
                    window.location.hash = '/Pedidos'
                }
            })
        }

        if(this.state.ofertasCargadas === false && this.props.dataContenido.ofertas !== undefined){
            let idOfertaSelected = this.props.dataContenido.ofertas[0].idOferta
            this.setState({ofertasCargadas: true, idOfertaSelected: idOfertaSelected, ofertaSelected:this.props.dataContenido.ofertas[0]}, () => {
                //buscar oferta
                //this.props.sagaGetOfertas(ofertaSelected)
            })
        }
    }

    handleOnClickDia = (fecha) => {
        this.setState(fecha)
    }

    handleOnChange = (e, ) => {
        let value = e.target.value
        let name = e.target.name
        
        let pathImg = this.state.pathImg
        let currentFile = this.state.currentFile
        
        this.setState({
            [name]: value
        })
    }

    validateTag(tag){
        var re = /^\w+$/;
        return re.test(String(tag).toUpperCase());
    }

    validateTagExists(tag1) {
        if(this.props.dataContenido.ofertas){
            var item = this.props.dataContenido.ofertas.find( x => x.tag === tag1)
            if(item !== undefined) {
                return true
            }
            else {
                return false
            }
        }
    }

    handleOnSave = () => {
        
        let error = {}
        let flag = false

        if(this.state.nombre === undefined || this.state.nombre === "" || this.state.nombre === null){
            error.nombre = "Ingrese un nombre para la oferta"
            flag = true
        }

        if(this.state.nombre !== undefined && this.state.nombre.length > 50){
            error.nombre = "Logitud máxima es de 50 caracteres"
            flag = true
        }

        if(this.state.tag === undefined || this.state.tag === "" || this.state.tag === null){
            error.tag = "Ingrese un tag para la oferta"
            flag = true
        }

        if(this.state.tag !== undefined && this.state.tag.length > 50){
            error.tag = "Logitud máxima es de 50 caracteres"
            flag = true
        }

        if(!this.validateTag(this.state.tag)) {
            error.tag = "Debe definir un tag sin espacios en blanco y sin caracteres especiales"
            flag = true
        }

        if(this.validateTagExists(this.state.tag) && this.state.tag !== undefined) {
            error.tag = "Ya existe en el sistema una oferta con el mismo tag. Debe ingresar un nuevo tag"
            flag = true
        }

        if(this.state.pathImg === undefined || this.state.currentFile  === undefined){
            error.imagen = "Debe arrastrar o elegir una imagen"
            flag = true
        }

        if(!this.state.fechaDesde || this.state.fechaDesde === undefined) {
            error.fechaDesde = "Debe ingresar una fecha"; 
            flag = true;
        }
        
        
        if(!this.state.fechaHasta || this.state.fechaHasta === undefined) {
            error.fechaHasta = "Debe ingresar una fecha"; 
            flag = true;
        }

        
        if(moment(this.state.fechaHasta).isBefore(this.state.fechaDesde)) {
            error.fechaHasta = "Debe ser mayor o igual a la fecha de inicio."
            flag = true
        } 
        

        //agregar validacion de archivo subido        
        this.setState({error: error}, () => {
            if(!flag){
                let payload = {
                    idOferta: undefined,
                    file: this.state.currentFile,
                    nombre: this.state.nombre,
                    tag: this.state.tag,
                    desde: this.state.fechaDesde,
                    hasta: this.state.fechaHasta,
                }

                localStorage.setItem('idOfertaSelected', JSON.stringify({idOfertaSelected:this.state.idOfertaSelected}));

                payload.callback = () => {
                    this.props.history.goBack();                    
                    //window.location.hash = '/Oferta'
                }

                this.props.sagaSabeOferta(payload)
            }
        })
    }

    handleOnDropFile = (acceptedFiles, rejectedFiles) => {
        
        
        if (rejectedFiles.length !== 0){
            if (rejectedFiles.length === 1) Notification.showError("Formato de Imagen no aceptado.")
            if (rejectedFiles.length > 1) Notification.showError("Se permite solo una imagen como portada de catálogo.")

        }
        else{
            if (acceptedFiles.length !== 0) {
                
                let currentFile = acceptedFiles[0]

                let ofertaSelected = this.state.ofertaSelected

                // genero una imagen para conocer sus dimesiones
                let _self = this
                let img = new Image()
                img.onload = function () {
                    
                    let width = this.width
                    let height = this.height

                    //if(ofertaSelected && ofertaSelected.idOferta === 1){
                        //width = 1417
                        //height = 222
                    //}

                    
                    //if(ofertaSelected && ofertaSelected.idOferta === 2){
                        width = 376
                        height = 307
                    //}
                    

                    // comprimo la imagen
                    let newSize = calculateNewSize(width, height, width*2, height*2)
                    compress(currentFile, currentFile.name, newSize.width, newSize.height, _self.onImageCompressed)
                }
                img.src = URL.createObjectURL(currentFile)
            }
        }                
    }

    onImageCompressed = (currentFile) => {
        //guardo en el estado una copia, para usarla al momento de guardar los recortes
        let currentFileCopy = currentFile
        let file = URL.createObjectURL(currentFile)
        
        this.setState({
            pathImg: file,
            currentFile: currentFileCopy,
            error: {...this.state.error, imagen: ''} 
        })
    }

    render() {
        return (
            <OfertaNuevo
                ofertaSelected={this.state.ofertaSelected}
                idOfertaSelected={this.state.idOfertaSelected}
                ofertas={this.props.dataContenido.ofertas}
                nombre={this.state.nombre}
                tag={this.state.tag}
                fechaDesde={this.state.fechaDesde}
                fechaHasta={this.state.fechaHasta}
                error={this.state.error}
                pathImg={this.state.pathImg}
                handleOnChange={this.handleOnChange}
                handleOnSave={this.handleOnSave}
                handleOnDropFile={this.handleOnDropFile}
                handleOnClickDia={this.handleOnClickDia}
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
        ...ofertaActions
	}, dispatch)
}

function mapStateToProps(state) {
	return {
        usuario: usuarioSelector(state),
        dataContenido: ofertaSelector(state)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(OfertaNuevoContainer)